// extracted by mini-css-extract-plugin
var _1 = "BeastPartLayers__bg--T4LUJ";
var _2 = "BeastPartLayers__button--sfKsx";
var _3 = "BeastPartLayers__controls--w7Avq";
var _4 = "BeastPartLayers__frame--z2bD5 BeastPartLayers__frameBase--l8vdx";
var _5 = "BeastPartLayers__frameBase--l8vdx";
var _6 = "BeastPartLayers__frameSelected--jYSpv BeastPartLayers__frameBase--l8vdx";
var _7 = "BeastPartLayers__img--Z6Fqk";
var _8 = "BeastPartLayers__layer--ol_eC";
var _9 = "BeastPartLayers__main--OsGwF";
var _a = "BeastPartLayers__part--J9vaS";
var _b = "BeastPartLayers__parts--cwXBD";
var _c = "BeastPartLayers__preview--rzlvr";
var _d = "BeastPartLayers__previewArea--MY4z0";
var _e = "BeastPartLayers__previewSelected--ERgEg";
var _f = "BeastPartLayers__scrollContent--Lhl7G";
export { _1 as "bg", _2 as "button", _3 as "controls", _4 as "frame", _5 as "frameBase", _6 as "frameSelected", _7 as "img", _8 as "layer", _9 as "main", _a as "part", _b as "parts", _c as "preview", _d as "previewArea", _e as "previewSelected", _f as "scrollContent" }
